<template>
  <ReportsPage
    :product="product"
    :product-data="productData"
    :forecast-subscription="forecastSubscription"
    hide-price-assessments-tab
  >
    <NuxtPage
      :product="product"
      :product-data="productData"
      :forecast-subscription="forecastSubscription"
    />
  </ReportsPage>
</template>

<script setup lang="ts">
import {
  PHOSPHATE,
  MARKET,
  SUBSCRIPTION_FORECASTS_PHOSPHATE,
} from '~/constants/services/constants'
import phosphateData from '~/constants/data-reports/phosphate'
import ReportsPage from '~/components/market/ReportsPage.vue'
import { useSeo } from '~/composables/useSeo'

definePageMeta({ layout: 'services' })

const product = ref(PHOSPHATE)
const productData = ref(phosphateData)
const forecastSubscription = ref(SUBSCRIPTION_FORECASTS_PHOSPHATE)

const { getSeoInfo } = useSeo()
const seo = getSeoInfo({
  title: `${MARKET.name}: ${PHOSPHATE.name} Data and Reports`,
})
useHead(seo)
</script>
